// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"7ec90db4764c20d13586","966":"44a30226504ec9ab8450"}[chunkId] + ".js";
};